import { useRef, useMemo } from 'react';
import { useSizeObserver } from '@shared/utils/hooks/useSizeObserver';

type UseResizerArgs = Readonly<{
  containerBaseWidth?: number;
}>;

export const useEcardScaling = ({ containerBaseWidth = 500 }: UseResizerArgs) => {
  const initialHeight = useRef<number | null>(null);

  const [size, nodeRef] = useSizeObserver();

  const ecardScalingState = useMemo(() => {
    if (!size.clientWidth || !size.clientHeight) {
      return {
        scale: 1,
        height: null,
      };
    }

    if (!initialHeight.current) {
      initialHeight.current = size.clientHeight;
    }

    const scale = Math.min(size.clientWidth / containerBaseWidth, 1);

    const nextHeight = initialHeight.current ? initialHeight.current * scale : size.clientHeight * scale;

    return {
      scale,
      height: nextHeight,
    };
  }, [size, containerBaseWidth]);

  return {
    ecardScalingState,
    nodeRef,
  };
};
